module.exports = __webpack_public_path__ + "media/villager.1fc2afec.wav";